import { CircularProgress, Stack } from "@mui/material";

const MiddlePageLoading = () => {
  return (
    <Stack direction="row" sx={{ justifyContent: "center", alignItems: "center", height: "80vh" }}>
      <CircularProgress />
    </Stack>
  );
};

export { MiddlePageLoading };
